import React, { useEffect, useState } from 'react';
import './Landingpage.scss';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';


import useCarousel from '../Admin/useCarousel';
import useCategories from '../Admin/useCategories';
import Loader from '../Loader/Loader';
import HotProducts from '../Content/HotProducts';
import NewArrival from '../Content/NewArrival';
import Categorysection from '../Mainpage/Categorysection';
import AlsoLike from '../Content/AlsoLike';
import BestReviews from '../Content/BestReviews';


const Landingpage = () => {
    const navigate = useNavigate();
    const { categories, loding, error
        , fetchcategories } = useCategories();
    const [index, setIndex] = useState(0);
    const { firstCarousel, secondCarousel, loading, error: carouselError } = useCarousel();
    const [landingData, setLandingData] = useState({});
    const [showFullAnnouncement, setShowFullAnnouncement] = useState(false);
    const [activeTab, setActiveTab] = useState('new');
    const productSectionRef = React.useRef(null);



    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };


    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };


    useEffect(() => {
        let isMounted = true;
        const fetchLanding = async () => {
            try {
                const response = await fetch('https://backend.indianjewelryish.com/api/fetch-landing');
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                if (isMounted) setLandingData(data);
            } catch (error) {
                if (isMounted) console.error('Failed to fetch landing page data:', error);
            }
        };
        fetchLanding();
        return () => {
            isMounted = false;
        };
    }, []);
    

    if (loading || loding) {
        return <div><Loader /></div>;
    }


    // console.log('Landing Data', landingData);

    return (
        <>
            <div id='landingpage'>
                <div id='carouselDiv'>
                    {firstCarousel.length > 0 ? (
                        <Carousel activeIndex={index} onSelect={handleSelect}>
                            {firstCarousel.map((carousel, idx) => (
                                <Carousel.Item key={idx}>
                                    <img
                                        className="d-block w-100"
                                        src={`https://backend.indianjewelryish.com/${carousel.image_path}`}
                                        alt={`First Carousel Slide ${idx + 1}`}
                                    />
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    ) : (
                        <p>No carousel items available.</p>
                    )}
                </div>

                <div id='borderLandingPage'></div>
                <section id='categoriesPhomeView'>
                    <div id='brouseCategoriesContent'></div>
                    <Categorysection />
                </section>
                <section id='landingSec'>
                    <h3 className="text-center mt-4 landing-heading">
                        SHOP BY CATEGORY
                    </h3>
                    <div className="category-scroll-wrapper mt-4">
                        <div className="category-scroll d-flex justify-content-around flex-nowrap">
                            {categories.map((category) => (
                                <div className="category-thumbnail text-center me-3">
                                    <Link to={`/category?category=${category.category_code}`}>
                                        <img src={`https://backend.indianjewelryish.com/${category.category_image}`} className='img-fluid' alt="" />
                                        <div className='linkLandingpage mt-2'>
                                            <h6 className='text-center'>{category.category_name}</h6>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                <div className='mt-4' id='borderLandingPage'></div>


                <section id='landingSec' ref={productSectionRef}>
                    <h3 className="text-center landing-heading mt-4">
                        <span
                            onClick={(e) => { e.preventDefault(); handleTabClick('new'); }}
                            style={{ fontWeight: activeTab === 'new' ? 'bold' : 'normal', cursor: 'pointer' }}
                        >
                            NEW ARRIVALS
                        </span> /
                        <span
                            onClick={(e) => { e.preventDefault(); handleTabClick('hot'); }}
                            style={{ fontWeight: activeTab === 'hot' ? 'bold' : 'normal', cursor: 'pointer' }}
                        >
                            HOT PRODUCTS
                        </span>
                    </h3>

                    <div id="mobileViewProductsDiv" className="mt-2 mx-2">
                        <div style={{ display: activeTab === 'new' ? 'block' : 'none' }}>
                            <NewArrival />
                        </div>
                        <div style={{ display: activeTab === 'hot' ? 'block' : 'none' }}>
                            <HotProducts />                            {/* Hot Products */}
                        </div>
                    </div>

                </section>


                <div id='borderLandingPage' className='my-4'></div>

                <section id='landingSec'>
                    <h3 className="text-center mt-4 landing-heading">
                        SHOP BY GUIDE
                    </h3>
                    <div className="category-scroll-wrapper mb-4">
                        <div className="category-scroll flex-nowrap">
                            <div className="price-thumbnail text-center me-3">
                                <Link className="linkLandingpage mt-2" to={`/product?guide=her`}>
                                    <img src={`https://backend.indianjewelryish.com/${landingData.landing.her}`} className="price-img" alt="For Her" />
                                </Link>
                            </div>
                            <div className="price-thumbnail text-center me-3">
                                <Link className="linkLandingpage mt-2" to={`/product?guide=mom`}>
                                    <img src={`https://backend.indianjewelryish.com/${landingData.landing.mom}`} className="price-img" alt="For Mom" />
                                </Link>
                            </div>
                            <div className="price-thumbnail text-center me-3">
                                <Link className="linkLandingpage mt-2" to={`/product?guide=friend`}>
                                    <img src={`https://backend.indianjewelryish.com/${landingData.landing.friend}`} className="price-img" alt="For Friend" />
                                </Link>
                            </div>
                            <div className="price-thumbnail text-center me-3">
                                <Link className="linkLandingpage mt-2" to={`/product?guide=sister`}>
                                    <img src={`https://backend.indianjewelryish.com/${landingData.landing.sister}`} className="price-img" alt="For Sister" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <div id='carouselDiv' className='mt-2 mb-2'>
                    {secondCarousel.length > 1 ? (
                        <Carousel activeIndex={index} onSelect={handleSelect}>
                            {secondCarousel.map((carousel, idx) => (
                                <Carousel.Item key={idx}>
                                    <img
                                        className="d-block w-100"
                                        src={`https://backend.indianjewelryish.com/${carousel.image_path}`}
                                        alt={`Carousel Slide ${idx + 1}`}
                                    />
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    ) : secondCarousel.length === 1 ? (
                        <Carousel >
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src={`https://backend.indianjewelryish.com/${secondCarousel[0].image_path}`}
                                    alt="Single Carousel Slide"
                                />
                            </Carousel.Item>
                        </Carousel>
                    ) : (
                        ""
                    )}
                </div>

                <section id='landingSec'>
                    <h3 className="text-center landing-heading my-4">SHOP BY PRICE</h3>
                    <div className="d-flex flex-column justify-content-between">
                        <div className="d-flex justify-content-evenly">
                            <Link className='price-card' to={`/product?price_min=0&price_max=15`}>
                                <img src={`https://backend.indianjewelryish.com/${landingData.landing.five}`} className='img-fluid' alt="" />
                            </Link>
                            <Link className='price-card' to={`/product?price_min=0&price_max=20`}>
                                <img src={`https://backend.indianjewelryish.com/${landingData.landing.fifteen}`} className='img-fluid' alt="" />
                            </Link>
                        </div>

                        <div className="d-flex justify-content-evenly mt-4 mb-4">
                            <Link className='price-card' to={`/product?price_min=0&price_max=25`}>
                                <img src={`https://backend.indianjewelryish.com/${landingData.landing.twenty}`} className='img-fluid' alt="" />
                            </Link>
                            <Link className='price-card' to={`/product?price_min=30&price_max=1000`}>
                                <img src={`https://backend.indianjewelryish.com/${landingData.landing.thirty}`} className='img-fluid' alt="" />
                            </Link>
                        </div>
                    </div>

                </section>

                <div id='borderLandingPage'></div>

                <section id="landingSec" className="py-5">
                    <div className="container">
                        <Link to={'/product?jewellery_type=gold'}>
                            <div className="row align-items-center mb-5">
                                <div className="col-lg-6 text-center mb-4 mb-lg-0">
                                    <img src={`https://backend.indianjewelryish.com/${landingData.landing.gold}`} className="img-fluid rounded shadow" alt="Gold Jewellery" />
                                </div>
                                <div className="col-lg-6">
                                    <h6 className="text-muted">
                                        {landingData.landing.gold_text}
                                    </h6>
                                </div>
                            </div>
                        </Link>
                        <Link to={'/product?jewellery_type=silver'}>
                            <div className="row align-items-center flex-lg-row-reverse">
                                <div className="col-lg-6 text-center mb-4 mb-lg-0">
                                    <img src={`https://backend.indianjewelryish.com/${landingData.landing.silver}`} className="img-fluid rounded shadow" alt="Silver Jewellery" />
                                </div>
                                <div className="col-lg-6">
                                    <h6 className="text-muted">
                                        {landingData.landing.silver_text}
                                    </h6>
                                </div>
                            </div>
                        </Link>
                    </div>
                </section>


                <div id='borderLandingPage'></div>

                <section id='landingSec' className='mb-4'>
                    <h3 className="text-center mt-4 landing-heading">
                        MAY YOU ALSO LIKE
                    </h3>
                    <div id="mobileViewProductsDiv" className="mt-2 mx-2">
                        <AlsoLike />
                    </div>
                    <div className="mt-2 mx-2 d-flex align-items-center justify-content-center">
                        <Link style={{ width: "100%" }} className='d-flex align-items-center justify-content-center' to={`/allproducts`}>
                            <button className='loginsignupbutton' style={{ width: "60%" }}>More Products</button>
                        </Link>
                    </div>
                </section>

                <div id='borderLandingPage'></div>

                <section id='landingSec' className='mb-4'>
                    <h3 className="text-center mt-4 landing-heading">
                        REVIEW TESTIMONIALS
                    </h3>
                    <div id="mobileViewProductsDiv" className="mt-2 mx-2">
                        <BestReviews />
                    </div>
                    <div className="mt-2 mx-2 d-flex align-items-center justify-content-center">
                        <Link style={{ width: "100%" }} className='d-flex align-items-center justify-content-center' to={'/all-best-reviews'}>
                            <button className='loginsignupbutton' style={{ width: "60%" }}>All Reviews</button>
                        </Link>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Landingpage;
